import { TableFilterDatePicker } from '@/components/table/table-filter-date-picker.js';
import { ComponentProps } from 'react';
import { Temporal } from 'temporal-polyfill';
import { localDateFromPlainDate, plainDateFromLocalDate } from '@/lib/time-zones.js';

interface TableFilterPlainDatePickerProps {
  selectedPlainDateString?: string;
  onPlainDateSelect: (newPlainDateString?: string) => void;
  tableFilterDatePickerProps?: ComponentProps<typeof TableFilterDatePicker>;
  onClear?: () => void;
  buttonTestId?: string;
}

export const TableFilterPlainDatePicker = ({
  selectedPlainDateString,
  onPlainDateSelect,
  tableFilterDatePickerProps,
  onClear,
  buttonTestId,
}: TableFilterPlainDatePickerProps) => {
  const { calendarProps = {}, ...others } = tableFilterDatePickerProps || {};
  return (
    <TableFilterDatePicker
      {...others}
      data-testid={buttonTestId}
      onClear={() => onClear?.()}
      calendarProps={{
        ...calendarProps,
        selected: selectedPlainDateString
          ? localDateFromPlainDate(Temporal.PlainDate.from(selectedPlainDateString))
          : undefined,
        onSelect: (newDate) => {
          onPlainDateSelect(newDate ? plainDateFromLocalDate(newDate).toString() : undefined);
        },
      }}
    />
  );
};
